import {
  IntegrationChannelViewFragment,
  IntegrationType,
} from 'generated/graphql';
import { toTitleCase } from 'v2/utils/strings';

export const getAddIntegrationDrawerHeaderTitle = (
  integrationChannel: IntegrationChannelViewFragment,
  integrationType: IntegrationType,
) => {
  return `${integrationChannel.displayName} - ${toTitleCase(
    integrationType,
  )} Integration`;
};
